import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { GeoJSON } from 'geojson';
import { validateGeometry as apiValidateGeometry } from '~/api/misc2';

export type UseValidateGeometryProps<T> = {
  geometry: T;
};

export type ValidationResult<T> = {
  geometry: T;
  isValid: boolean;
  isValidReason: string;
};

export function useValidateGeometry<T = GeoJSON>(
  { geometry }: UseValidateGeometryProps<T>,
  options?: Partial<
    UseQueryOptions<ValidationResult<T>, Error, ValidationResult<T>, (string | UseValidateGeometryProps<T>)[]>
  >,
) {
  return useQuery({
    enabled: !!geometry,
    queryKey: ['validate-geometry', { geometry }],
    queryFn: () => apiValidateGeometry<T>(geometry),
    ...options,
  });
}
